import type { FC } from 'react'
import { useTheme } from '@emotion/react'

import styled from '@emotion/styled'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Navigation from '@segment/templates/Navigation'
import GettingStarted from '@segment/templates/GettingStarted'
import Footer from '@segment/templates/Footer'

import Layout from '@segment/next-shared/layout'

import Hero from './components/Hero'
import LinkedProfiles from './components/LinkedProfiles'
import UseAI from './components/UseAI'
import TrackInteractions from './components/TrackInteractions'
import GetHistory from './components/GetHistory'
import PowerPersonalization from './components/PowerPersonalization'
import UnlockAnalytics from './components/UnlockAnalytics'
import ActivateProfiles from './components/ActivateUnify'
import RelatedContent from './components/RelatedContent'
import FaqSection from './components/FaqSection'

import ogImagePng from './assets/OgUnify.png'

const UnifyView: FC = () => {
  const theme = useTheme()
  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle="Unify: A Complete View of Your Customer with Identity Resolution | Twilio Segment"
        pageDescription="Segment Unify provides a complete view of your customer with deterministic identity resolution across devices, platforms and channels. Learn how Unify creates a golden profile."
        themeColor={theme.palette.neutrals.white[100]}
        bodyBackground={theme.palette.neutrals.white[100]}
        pageOG={ogImagePng}
      >
        <Navigation />
        <Hero />
        <Main>
          <LinkedProfiles />
          <UseAI />
          <TrackInteractions />
          <GetHistory />
          <PowerPersonalization />
          <UnlockAnalytics />
          <ActivateProfiles />
          <RelatedContent />
          <FaqSection />
          <GettingStarted />
        </Main>
        <Footer />
      </Layout>
    </AppearanceProvider>
  )
}

export default UnifyView

const Main = styled.main``
